export default "__VITE_ASSET__DAWMOXmw__"